import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.cashflow');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-cashflow',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.cashflow/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCashflowComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public year: number = new Date().getFullYear();
    public feeRows: any[] = [];
    public availableYears: number[] = [];
    public uniqueFundCount: number = 0;
    public totalFeeAmount: number = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.loadData();
    }

    public async loadData() {
        const { code, data } = await wiz.call("mgmt_fees", { year: this.year });
        if (code == 200) {
            this.feeRows = data.rows || [];
            this.availableYears = data.available_years || [];
            this.year = data.year || this.year;

            const fundIds = new Set(this.feeRows.map((r: any) => r.fund_id));
            this.uniqueFundCount = fundIds.size;
            this.totalFeeAmount = this.feeRows.reduce((sum: number, r: any) => sum + (r.amount || 0), 0);
        }
        await this.service.render();
    }

    public formatCurrency(amount: number): string {
        if (!amount) return '0';
        return amount.toLocaleString();
    }

    public async prevYear() {
        this.year--;
        await this.loadData();
    }

    public async nextYear() {
        this.year++;
        await this.loadData();
    }

    public async togglePaid(row: any) {
        const newPaid = !row.paid;
        const { code } = await wiz.call("toggle_paid", {
            fund_id: row.fund_id,
            paid_key: row.paid_key,
            paid: String(newPaid)
        });
        if (code == 200) {
            row.paid = newPaid;
            await this.service.render();
        }
    }

    public async toggleFrequency(row: any) {
        const newFreq = row.frequency === 'quarterly' ? 'annual' : 'quarterly';
        const { code } = await wiz.call("set_frequency", {
            fund_id: row.fund_id,
            frequency: newFreq
        });
        if (code == 200) {
            await this.loadData();
        }
    }
}

export default PortalLpsysadminCashflowComponent;